<div class="card-wrap recc-card" (click)="routeToLiveStream(liveInfo)">
    <div class="card paid-card text-left">
        <div class="clip-img card-variant">
            <img [src]="imageUrl+liveInfo?.thumbnailUrl?.path+liveInfo?.thumbnailUrl?.name "  class="card-img-top" alt="card image" />
            <span class="clip-icn"><img src="assets/images/video-icon.svg" alt="video-icon"/></span>
            <p class="info">
                <img class="watch-icn" src="assets/images/watch-icn.svg" alt="watch" />
                <span class="time" *ngIf="liveInfo?.duration">
                        {{ liveInfo?.startDate | date:'medium'}}  
                </span>
            </p>
            <p  class="info info-desc">
                <img class="watch-icn" src="assets/images/watch-icn.svg" alt="watch" />
                <span class="time" *ngIf="liveInfo?.duration">
                        {{ liveInfo?.duration }} Mins 
                </span>
            </p>
            <span class="clip-tagtxt">
                {{ liveInfo?.label }}
            </span>
            <!-- <span class="card-heart-icn" >
                <img src="assets/images/heart-icn.svg" alt="">
            </span> -->
        </div>
        <div class="card-body">
            <div class="schedule d-flex justify-content-between">
                <p class="card-text"> {{ liveInfo?.title}}</p>
                <span class="lavel"><img src="assets/images/2.png" alt="graph" /> 
                    {{liveInfo?.level}}
                </span>
            </div>

            <div class="card-tags text-md-left">
                <a class="tag" *ngFor="let i of liveInfo?.tagData | slice:0:5">
                    {{i?.name}}
                </a>
            </div>
            <div class="card-profile">
                <div class="profile-name" *ngIf="liveInfo?.instructor">
                    <span class="profile-img"><img [src]="imageUrl+liveInfo?.instructor[0]?.image?.path + liveInfo?.instructor[0]?.image?.name" alt="profile" /></span>
                    <span class="name"><span>{{ liveInfo?.instructor[0]?.firstName}} {{ liveInfo?.instructor[0]?.lastName}}</span></span>
                </div>
                <a *ngIf="liveInfo?.amount"  class="card-price">&#36; {{liveInfo?.amount}}</a>
            </div>
        </div>
    </div>
</div>